import * as React from "react";

function SvgCheckCircleDuo({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="#374151"
          d="M12 2.25l-.276.004C6.449 2.407 2.25 6.722 2.25 12l.004.276C2.407 17.551 6.722 21.75 12 21.75l.276-.004c5.275-.153 9.474-4.468 9.474-9.746l-.004-.276C21.593 6.449 17.278 2.25 12 2.25z"
        />
        <path
          fill="#98DB69"
          d="M12 3.75a8.248 8.248 0 018.246 8.006l.004.255c0 4.455-3.553 8.107-8.006 8.235l-.255.004c-4.455 0-8.107-3.553-8.235-8.006l-.004-.255c0-4.455 3.553-8.107 8.006-8.235L12 3.75zm4.53 5.72a.749.749 0 00-1.06 0L11 13.939l-2.47-2.47-.084-.072a.748.748 0 00-.976 1.133l3 3 .084.073c.293.218.71.194.976-.073l5-5 .073-.084a.748.748 0 00-.073-.976z"
        />
      </g>
    </svg>
  );
}

export default SvgCheckCircleDuo;
